import React from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 30px;
  width: 100%;
  background-color: teal;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
`;
const Announcement = () => {
  return (
    <Container>
      <marquee>
        Super Deal, 50% discount on shipping for items over &#8358;100,000.00
      </marquee>
    </Container>
  );
};

export default Announcement;
